import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGatepassTypes = createAsyncThunk("fetchGatepassTypes", async (_, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`category/list?page=1&limit=1000&categoryType=Gatepass`);
		return Array.isArray(response?.data?.data?.docs) ? response.data.data.docs : [];
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const GatepassTypesSlice = createSlice({
	name: "GatepassTypesSlice",
	initialState: {
		isLoading: false,
		data: [],
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchGatepassTypes.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchGatepassTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchGatepassTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GatepassTypesSlice.reducer;
